module.exports = __webpack_public_path__ + "img/Wrong.127c559f.png";